import { cj } from 'src/utils/classNames';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import {
	CategorisedLiquidity,
	CUMULATIVE_SIZE_CURRENCY,
	trimTrailingZeros,
} from '@velocity-exchange/common';
import { BigNum, BN } from '@velocity-exchange/sdk';

interface OrderbookRowCumulativeSizeProps {
	cumulativeSize: CategorisedLiquidity;
	baseDisplayDecimals: number;
	isMobile: boolean;
	className: string;
	currency: CUMULATIVE_SIZE_CURRENCY;
	cumulativeAveragePrice: number;
}

export const OrderbookRowCumulativeSize = ({
	cumulativeSize,
	baseDisplayDecimals,
	isMobile,
	className,
	currency,
	cumulativeAveragePrice,
}: OrderbookRowCumulativeSizeProps) => {
	const set = useDriftStore((s) => s.set);

	const cumulativeTotalSize = Object.values(cumulativeSize).reduce(
		(acc, curr) => acc + curr,
		0
	);

	const displayValue =
		currency === CUMULATIVE_SIZE_CURRENCY.USD && cumulativeAveragePrice
			? cumulativeTotalSize * cumulativeAveragePrice
			: cumulativeTotalSize;

	const displayDecimals =
		currency === CUMULATIVE_SIZE_CURRENCY.USD ? 0 : baseDisplayDecimals;

	const formattedCumulativeSize = BigNum.fromPrint(
		displayValue.toFixed(displayDecimals),
		new BN(displayDecimals)
	).toMillified();

	const handleSizeClick = (size: number) => {
		set((state) => {
			state.tradeForm.leadSide = 'base';
			// Round size to 5 decimals... avoids a bunch of zeroes in trade form
			const roundTo = 10 ** 5;
			// @ts-expect-error - we want to override the readonly property
			state.tradeForm.baseSizeStringValue = trimTrailingZeros(
				(Math.round(size * roundTo) / roundTo).toString()
			);
		});
	};

	return (
		<span
			className={cj(
				'inline-flex items-center justify-end text-right',
				!isMobile && 'hover:cursor-pointer hover:brightness-125',
				className
			)}
			onClick={() => handleSizeClick(cumulativeTotalSize)}
		>
			{formattedCumulativeSize}
		</span>
	);
};
